import { Container, Row, Col, Button } from 'react-bootstrap';
import './privicypolicy.css';


function PolicyBanner() {
  return (
    <div>
      <div className="privicy-banner-section">
        <div className="privicy-banner-overlay" />
        <Container className="theme-container">
          <Row className="align-items-center">
            <Col md={7}>
              <div className='privicy-banner-content'>
                <p className="section-subtitle mb-xl-2 mb-1">YOUR PERSONAL INFORMATION</p>
                <h2 className="section-sub-title mb-xl-3 mb-2">
                  privacy policy
                </h2>
                <p className="privicy-banner-description fontsize-20">
                  Committed to protecting any personal information you share with us.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  )
}

export default PolicyBanner
